<accordion [isAnimated]="true" [closeOthers]="true">
    @if (items().length === 0) {
        <alert type="info" class="m-2">No addresses to display.</alert>
    } @else {
        @for (addr of items(); track $index) {
            <accordion-group [isOpen]="$index === 0" [heading]="addr.heading">
                <div class="addr-summary">
                    @for (line of addr.summary; track $index) {
                        <div class="addr-summary-line">{{ line }}</div>
                    }
                </div>

                <hr class="my-3" />

                <div class="table-responsive">
                    <table class="table table-sm table-striped table-hover align-middle">
                        <thead class="table-light">
                            <tr>
                                <th style="width: 220px">Field</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of addr.details | keyvalue; track row.key) {
                                <tr>
                                    <td class="text-muted">{{ row.key }}</td>
                                    <td>
                                        <pre class="mb-0 pretty">{{ row.value }}</pre>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </accordion-group>
        }
        <accordion-group heading="Raw JSON">
            <div class="d-flex flex-row justify-content-end gap-2">
                <button type="button" class="btn btn-sm btn-info" (click)="copyJson()">Copy JSON</button>
                <button type="button" class="btn btn-sm btn-info" (click)="triggerDownloadJson()">Download JSON</button>
            </div>
            <pre class="small mb-0">{{ addresses() | json }}</pre>
        </accordion-group>
    }
</accordion>

<div class="d-flex flex-row justify-content-end gap-2 mt-3">
    <button
        type="button"
        class="btn btn-danger"
        (click)="triggerDeleteLocal()"
        translate="PACESPECTOR_DELETE_LOCAL"
    ></button>
</div>
